import AuthLand from '../components/AuthLand';
export default AuthLand; 